import { notificationSchema } from "@features/vessel-call/vessel-call-status/PortServices/flow/utils";
import i18n from "i18next";
import { z } from "zod";
import {
  createAtcSchema,
  PORT_SERVICE_FIELDS_LANG_BASE,
  withAtcAfterAtsValidation,
} from "./sharedClosePortServiceSchemas";

const LANG_BASE = PORT_SERVICE_FIELDS_LANG_BASE;

const wasteResiduesForDischargeFacilitySchema = z.object({
  wasteResiduesForDischargeFacility: z
    .array(
      z.object({
        marpolAnnexIOil: z.string().optional(),
        otherSpecifyDetails: z.string().optional(),
        quantityM3: z.number().optional(),
      }),
    )
    .optional(),
});

const slopsDisposalDocumentsSchema = z.object({
  slopsDisposalDocuments: z
    .array(
      z.object({
        documentUrl: z.string().optional(),
        documentName: z.string().optional(),
        fileType: z.string().optional(),
      }),
    )
    .superRefine((val, ctx) => {
      const hasDocument = !!val?.length && val.every((document) => !!document.documentUrl?.trim());

      if (!hasDocument) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["slopsDisposalDocuments"],
          message: i18n.t("form-validation.mandatory", {
            label: i18n.t(`${LANG_BASE}.slops-disposal-images`),
          }),
        });
      }
    }),
});

const serviceReportAttachmentSchema = z.object({
  serviceReportAttachment: z
    .object({
      documentUrl: z.string().optional(),
      documentName: z.string().optional(),
      fileType: z.string().optional(),
    })
    .superRefine((val, ctx) => {
      const hasDocument = !!val?.documentUrl?.trim();

      if (!hasDocument) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["serviceReportAttachment"],
          message: i18n.t("form-validation.mandatory", {
            label: i18n.t(`${LANG_BASE}.service-report-attachment`),
          }),
        });
      }
    }),
});

export const closeSlopsDisposalSchema = (ats?: string | Date | null) =>
  withAtcAfterAtsValidation(
    (createAtcSchema("mandatory") as z.AnyZodObject)
      .merge(slopsDisposalDocumentsSchema)
      .merge(serviceReportAttachmentSchema)
      .merge(wasteResiduesForDischargeFacilitySchema)
      .merge(notificationSchema),
    ats,
  );

export type CloseSlopsDisposalSchema = z.infer<ReturnType<typeof closeSlopsDisposalSchema>>;
